// removed by extract-text-webpack-plugin
module.exports = {"form-row":"_30ql","mandate-acceptance":"_15qn"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddBankAccountForm/BillingAddBankAccountForm.scss
// module id = mpA8
// module chunks = 0